module.exports = new __parcel__URL__("merchant.5f2716b8.html").toString();